export const blockIconsSearchDoorBack = (
	<span className='material-symbols-outlined'>door_back</span>
);
